import { Stack, Typography } from "@mui/material";
import { COLORS } from "style";
import { TaskWithRelated } from "type/model/api";
import { transformEnumValue } from "utility/transformer";

interface Props {
  tasks: TaskWithRelated[];
}

const TaskDetails = ({ task }: { task: TaskWithRelated }) => {
  return (
    <Stack sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
      <Typography variant="body2" color={COLORS.CYNICAL_BLACK}>
        {task.patient_identifier ?? "[Not Set]"}
      </Typography>

      <Typography variant="body2" color={COLORS.SHADOW_GARGOYLE}>
        {transformEnumValue(task.patient_priority) ?? "[Not Set]"}
      </Typography>

      <Typography variant="body2" color={COLORS.SHADOW_GARGOYLE}>
        {task.from_hospital?.name ?? "[Not Set]"} to {task.to_hospital?.name ?? "[Not Set]"}
      </Typography>
    </Stack>
  );
};

export const MultiPatientDetails = ({ tasks }: Props) => {
  return (
    <Stack sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {tasks.map((task) => (
        <TaskDetails key={task.id} task={task} />
      ))}
    </Stack>
  );
};
